module.exports = __webpack_public_path__ + "img/icon_euro.5e2965cd.svg";